"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var classNames = require("classnames");
var React = require("react");
var Cell = /** @class */ (function (_super) {
    __extends(Cell, _super);
    function Cell() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Cell.prototype.render = function () {
        var _a = this.props, rowIndex = _a.rowIndex, colIndex = _a.colIndex;
        var content = this.renderCell(this.props.cell, this.props.row);
        var columnWidth = this.props.columnWidth ? "col-md-" + this.props.columnWidth : '';
        var dataClasses = classNames({
            "hide": this.props.isHidden,
            "text-nowrap": this.props.nowrap
        }, columnWidth);
        return React.createElement("td", { className: dataClasses, key: "row-" + (rowIndex + 1) + "-col-" + colIndex }, content);
    };
    Cell.prototype.renderCell = function (cell, row) {
        if (typeof cell === "string") {
            return cell;
        }
        return cell(row);
    };
    return Cell;
}(React.Component));
exports.Cell = Cell;
//# sourceMappingURL=Cell.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@abb/common-ux/dist/components/Table/Cell.js
// module id = 598
// module chunks = 1